import { ILoginVNPTRequest } from "../../model/request/auth/ILoginVNPTRequest"
import { ILoginRequest } from "../../model/request/ILoginRequest"
import { apiClient } from "../apiClient"
import { apiGuestClient } from "../apiGuestClient"

export const authApi = {
    getUser: () => apiClient.get('user/info'),
    logIn: (request: ILoginRequest) => {
        return apiGuestClient.post(`user/loginSSO`, request)
    },
    logOut: () =>  apiClient.get('user/logout'),
     getUserVNPT: () => apiClient.get("user/info-vnpt"),
    logInVNPT: (request: ILoginVNPTRequest) => {
    return apiGuestClient.post(`user/login-vnpt`, request);
  },

}